import catImage2 from '../assets/cat-pic2.jpg';

const RedirectMessage = () => {
  const containerStyle = {
    height: '100vh',
    width: '100vw',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  };

  const imageStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  };

  const messageStyle = {
    fontSize: '24px',
    color: '#fff',
    textAlign: 'center',
    padding: '20px',
    position: 'relative',
    zIndex: 2,
    textShadow: '0 2px 8px rgba(0, 0, 0, 0.6)',
  };

  const overlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.4)',
    zIndex: 1,
  };

  return (
    <div style={containerStyle}>
      <img
        src={catImage2}
        alt="Cat"
        style={imageStyle}
      />
    </div>
  );
}

export default RedirectMessage;
